import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import MasterDataUserMenu from '../../../components/MasterData/MasterDataUserMenu';
import MasterDataUserFirstPage from '../../../components/MasterData/MasterDataUserFirstPage';
import MasterDataUserSecondPage from '../../../components/MasterData/MasterDataUserSecondPage';
import MasterDataUserThirdPage from '../../../components/MasterData/MasterDataUserThirdPage';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_USER_INSERT } from '../../../constants/menuPermissionConstant';
import { getContent, getErrorMessage } from '../../../util/responseUtil';
import IconStatusCheck from '../../../assets/icons/IconStatusCheck';
import IconStatusWarn from '../../../assets/icons/IconStatusWarn';
import API_SEARCH from '../../../api/apiSearch';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';

class UserAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            clientId: '',
            id: 0,
            userCategory: {
                data: [
                    {
                        value: 'nexsoft',
                        label: 'Nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'Distributor'
                    },
                    {
                        value: 'principal',
                        label: 'Principal'
                    }
                ],
                value: ''
            },
            isCustomerService: false,
            assignable: false,
            email: '',
            language: {
                placeholder: 'Indonesia',
                value: 'id-ID'
            },
            level: {
                data: [
                    {
                        value: 'cslv1',
                        label: 'Level 1'
                    },
                    {
                        value: 'cslv2',
                        label: 'Level 2'
                    }
                ],
                value: ''
            },
            specialization: {
                data: [],
                value: []
            },
            lead: {
                data: [],
                value: ''
            },
            isLead: false,
            distributor: {
                page: 1,
                limit: 10,
                data: [],
                value: []
            },
            idCard: '',
            title: {
                data: [
                    {
                        value: 'Tn',
                        label: 'Tn'
                    },
                    {
                        value: 'Ny',
                        label: 'Ny'
                    },
                    {
                        value: 'Nn',
                        label: 'Nn'
                    }
                ],
                value: ''
            },
            firstName: '',
            lastName: '',
            gender: {
                data: [
                    {
                        value: 'L',
                        label: 'Laki-Laki'
                    },
                    {
                        value: 'P',
                        label: 'Perempuan'
                    }
                ],
                value: ''
            },
            countryCode: '+62',
            phoneNumber: '',
            createdAt: '',
            updatedAt: '',
            updatedBy: '',
            username: '',
            password: '',
            confirmPassword: '',
            role: {
                page: 1,
                limit: 10,
                data: [],
                value: ''
            },
            dataGroup: {
                page: 1,
                limit: 10,
                data: [],
                value: ''
            },
            emailAlreadyInNexcare: false,
            phoneAlreadyInNexcare: false,
            emailAlreadyInAuthentication: false,
            phoneAlreadyInAuthentication: false,
            detailUser: {},
            detailUserEmail: {},
            detailUserPhone: {},
            showSelectUserCategoryModal: false,
            showAlert: false,
            canAddUser: false,
            messageAlert: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListSpeacialization = () => {
        API_MASTER_DATA.getListComplaint(1, 100, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let complaintData = getContent(res).map(complaint => ({
                        value: complaint.id,
                        label: complaint.complaint_description
                    }))
                    this.setState({
                        specialization: {
                            ...this.state.specialization,
                            data: complaintData
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListCustomerService = () => {
        API_MASTER_DATA.getAllCustomer(1, 100, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerService = getContent(res).map(cs => ({
                        value: cs.user_nexcare_id,
                        label: cs.name
                    }))
                    this.setState({
                        lead: {
                            ...this.state.lead,
                            data: customerService
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDistributor = () => {
        API_MASTER_DATA.getListCustomer(this.state.distributor.page, this.state.distributor.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let distributor = getContent(res).map(distributor => ({
                        value: distributor.id,
                        label: distributor.customer_name
                    }))
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributor
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchDistributor = keyword => {
        API_MASTER_DATA.getSearchCustomer(this.state.distributor.page, this.state.distributor.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let distributor = getContent(res).map(distributor => ({
                        value: distributor.id,
                        label: distributor.customer_name
                    }))
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributor
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListRole = userCategory => {
        API_MASTER_DATA.getListFilterRoleUser(this.state.role.page, this.state.role.limit, userCategory, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let role = getContent(res).map(role => ({
                        value: role.id,
                        label: role.role_id
                    }))
                    this.setState({
                        role: {
                            ...this.state.role,
                            data: role
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchRole = keyword => {
        API_SEARCH.getListFilterRoleUser(this.state.role.page, this.state.role.limit, keyword, this.state.userCategory.value.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let role = getContent(res).map(role => ({
                        value: role.id,
                        label: role.role_id
                    }))
                    this.setState({
                        role: {
                            ...this.state.role,
                            data: role
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDataGroup = () => {
        API_MASTER_DATA.getListDataGroupUser(this.state.dataGroup.page, this.state.dataGroup.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let dataGroup = getContent(res).map(dataGroup => ({
                        value: dataGroup.id,
                        label: dataGroup.group_id
                    }))
                    this.setState({
                        dataGroup: {
                            ...this.state.dataGroup,
                            data: dataGroup
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchDataGroup = keyword => {
        API_SEARCH.getListDataGroupUser(this.state.dataGroup.page, this.state.dataGroup.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let dataGroup = getContent(res).map(dataGroup => ({
                        value: dataGroup.id,
                        label: dataGroup.group_id
                    }))
                    this.setState({
                        dataGroup: {
                            ...this.state.dataGroup,
                            data: dataGroup
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDetailUserEmail = () => {
        const data = {
            email: this.state.email
        }

        return API_AUTHENTICATION.postDetailUser(data, this.props.token)
            .then(res => {
                let emailNexcare
                if (res.data.nexsoft.payload.other === null && getContent(res).client_id === '') emailNexcare = false
                if (res.data.nexsoft.payload.other === null && getContent(res).client_id !== '') emailNexcare = true
                if (res.data.nexsoft.payload.other === 'Data belum ada di Authentication, sudah ada di nexcare') emailNexcare = true
                if (res.data.nexsoft.payload.other === 'Data Sudah Ada di Auth, tapi belum ada di Nexcare') emailNexcare = false

                if (getContent(res).client_id === '') {
                    return this.setState({
                        emailAlreadyInNexcare: emailNexcare,
                        emailAlreadyInAuthentication: false,
                        detailUserEmail: getContent(res)
                    })
                }

                this.setState({
                    emailAlreadyInNexcare: emailNexcare,
                    emailAlreadyInAuthentication: true,
                    detailUserEmail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 400) {
                    this.setState({
                        emailAlreadyInNexcare: false,
                        emailAlreadyInAuthentication: false
                    })
                }
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDetailUserPhone = () => {
        const data = {
            phone: this.state.countryCode + "-" + this.state.phoneNumber
        }

        return API_AUTHENTICATION.postDetailUser(data, this.props.token)
            .then(res => {
                let phoneNexcare
                if (res.data.nexsoft.payload.other === null && getContent(res).client_id === '') phoneNexcare = false
                if (res.data.nexsoft.payload.other === null && getContent(res).client_id !== '') phoneNexcare = true
                if (res.data.nexsoft.payload.other === 'Data belum ada di Authentication, sudah ada di nexcare') phoneNexcare = true
                if (res.data.nexsoft.payload.other === 'Data Sudah Ada di Auth, tapi belum ada di Nexcare') phoneNexcare = false

                if (getContent(res).client_id === '') {
                    return this.setState({
                        phoneAlreadyInNexcare: phoneNexcare,
                        phoneAlreadyInAuthentication: false,
                        detailUserPhone: getContent(res)
                    })
                }

                this.setState({
                    phoneAlreadyInNexcare: phoneNexcare,
                    phoneAlreadyInAuthentication: true,
                    detailUserPhone: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 400) {
                    this.setState({
                        phoneAlreadyInNexcare: false,
                        phoneAlreadyInAuthentication: false
                    })
                }
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeUserCategory = data => {
        if (data.value === 'nexsoft') {
            this.setState({ isCustomerService: true })
        }
        this.setState({
            userCategory: {
                ...this.state.userCategory,
                value: data
            }
        })
    }

    handleChangeAssignable = async () => {
        await this.setState({
            assignable: !this.state.assignable
        })
        this.setState({
            userCategory: {
                ...this.state.userCategory,
                value: {
                    value: this.state.assignable ? 'cso' : 'nexsoft',
                    label: 'Nexsoft'
                }
            }
        })
        this.getListRole(this.state.userCategory.value.value)
    }

    handleChangeIsLead = () => {
        this.setState({
            isLead: !this.state.isLead
        })
    }

    handleChangeLanguage = data => {
        this.setState({
            language: {
                ...this.state.language,
                value: data
            }
        })
    }

    handleChangeGender = data => {
        this.setState({
            gender: {
                ...this.state.gender,
                value: data
            }
        })
    }

    handleChangeLevel = data => {
        this.setState({
            level: {
                ...this.state.level,
                value: data === null ? '' : data
            }
        })
    }

    handleChangeSpecialization = data => {
        this.setState({
            specialization: {
                ...this.state.specialization,
                value: data
            }
        })
    }

    handleChangeLead = data => {
        this.setState({
            lead: {
                ...this.state.lead,
                value: data === null ? '' : data
            }
        })
    }

    handleChangeDistributor = data => {
        this.setState({
            distributor: {
                ...this.state.distributor,
                value: data
            }
        })
    }

    handleSearchDistributor = keyword => {
        if (keyword !== '') {
            return this.getSearchDistributor(keyword);
        }
        return this.getListDistributor();
    }

    handleChangeTitle = data => {
        this.setState({
            title: {
                ...this.state.title,
                value: data
            }
        })
    }

    handleChangeRole = data => {
        this.setState({
            role: {
                ...this.state.role,
                value: data
            }
        })
    }

    handleSearchRole = keyword => {
        if (keyword !== '') {
            return this.getSearchRole(keyword);
        }
        return this.getListRole(this.state.userCategory.value.value);
    }

    handleChangeDataGroup = data => {
        this.setState({
            dataGroup: {
                ...this.state.dataGroup,
                value: data
            }
        })
    }

    handleSearchDataGroup = keyword => {
        if (keyword !== '') {
            return this.getSearchDataGroup(keyword);
        }
        return this.getListDataGroup();
    }

    handleChangePage = page => {
        this.setState({ page })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeEmail = async e => {
        await this.handleChange(e)

        this.setState({
            showAlert: false,
            canAddUser: false,
            showWarningAlertEmail2: false
        })

        const validateEmail = /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        if (!this.state.email.match(validateEmail)) {
            return this.setState({
                showWarningAlertEmail: true,
                isAddUserValid: false
            })
        }
        return this.setState({
            showWarningAlertEmail: false,
            isAddUserValid: true
        })
    }

    handleChangePhone = async e => {
        await this.handleChange(e)

        this.setState({
            showAlert: false,
            canAddUser: false,
            showWarningAlertPhone2: false
        })

        const validatePhone = /^(^\+62|62|^8)(\d{3,4}-?){2}\d{3,4}$/
        if (!this.state.phoneNumber.match(validatePhone)) {
            return this.setState({
                showWarningAlertPhone: true,
                isAddUserValid: false
            })
        }
        return this.setState({
            showWarningAlertPhone: false,
            isAddUserValid: true
        })
    }

    handleCheckUser = () => {
        if (this.state.showWarningAlertEmail || this.state.showWarningAlertEmail2 || this.state.showWarningAlertPhone || this.state.showWarningAlertPhone2) return

        // Data Email & No Telp Nexcare dan Authentication Tidak Sama
        if (this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare === undefined && !this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'Data Email dan Nomor Telepon di Nexcare dan Authentication berbeda!'
            })
        }

        if (this.state.emailAlreadyInNexcare === undefined && this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'Data Email dan Nomor Telepon di Nexcare dan Authentication berbeda!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare === undefined && !this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'Data Email dan Nomor Telepon di Nexcare dan Authentication berbeda!'
            })
        }

        if (this.state.emailAlreadyInNexcare === undefined && !this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'Data Email dan Nomor Telepon di Nexcare dan Authentication berbeda!'
            })
        }

        // User Sudah Terdaftar di Nexcare
        if (this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id === '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare!'
            })
        }

        if (this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare!'
            })
        }

        if (this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id === '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare!'
            })
        }

        // User Sudah Terdaftar di Nexcare, namun Tidak Terdaftar di Authentication
        if (this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.nexcare_id !== this.state.detailUserPhone.nexcare_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare, namun tidak terdaftar di Authentication!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.nexcare_id !== this.state.detailUserPhone.nexcare_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare, namun tidak terdaftar di Authentication!'
            })
        }

        if (this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.nexcare_id !== this.state.detailUserPhone.nexcare_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'User sudah terdaftar pada Nexcare, namun tidak terdaftar di Authentication!'
            })
        }

        // User Sudah Terdaftar di Authentication, namun Belum Terdaftar di Nexcare
        if (!this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
                return this.setState({
                    showAlert: true,
                    canAddUser: false,
                    messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
                })
            }

            return this.setState({
                showAlert: true,
                canAddUser: true,
                messageAlert: 'User sudah terdaftar pada Authentication, namun belum terdaftar di Nexcare!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: true,
                messageAlert: 'User sudah terdaftar pada Authentication, namun belum terdaftar di Nexcare!'
            })
        }

        if (!this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: true,
                messageAlert: 'User sudah terdaftar pada Authentication, namun belum terdaftar di Nexcare!'
            })
        }

        // User Belum Terdaftar di Authentication
        if (!this.state.emailAlreadyInNexcare && !this.state.phoneAlreadyInNexcare && !this.state.emailAlreadyInAuthentication && !this.state.phoneAlreadyInAuthentication) {
            return this.setState({
                showAlert: true,
                canAddUser: true,
                messageAlert: 'User belum terdaftar pada authentication!'
            })
        }

        // Data Email & No Telp User Tidak Sama
        if (this.state.detailUserEmail.client_id !== '' && this.state.detailUserPhone.client_id !== '' && this.state.detailUserEmail.client_id !== this.state.detailUserPhone.client_id) {
            return this.setState({
                showAlert: true,
                canAddUser: false,
                messageAlert: 'Email dan Nomor Telepon terdaftar di user yang berbeda. Silahkan gunakan Email dan Nomor Telepon yang benar!'
            })
        }

        // Selain pengkondisian di atas
        return this.setState({
            showAlert: true,
            canAddUser: false,
            messageAlert: 'Silahkan periksa kembali Email dan Nomor Telepon Anda!'
        })
    }

    handleSubmitUserCategoryModal = async e => {
        e.preventDefault();

        await this.setState({ showWarningUserCategory: false })

        if (this.state.userCategory.value === '') {
            return this.setState({ showWarningUserCategory: true })
        }

        if (this.state.email === '') {
            return this.setState({ showWarningAlertEmail2: true })
        }

        if (this.state.phoneNumber === '') {
            return this.setState({ showWarningAlertPhone2: true })
        }

        await this.getDetailUserEmail();
        await this.getDetailUserPhone();

        this.handleCheckUser();
    }

    handleSubmitInitiateUser = e => {
        e.preventDefault();

        if (this.state.canAddUser) {
            this.getListRole(this.state.userCategory.value.value);
            this.getListDataGroup();

            if (this.state.userCategory.value.value === 'nexsoft') {
                this.getListCustomerService();
                this.getListSpeacialization();
            }

            if (this.state.userCategory.value.value === 'distributor') {
                this.getListDistributor();
            }

            if (this.state.emailAlreadyInAuthentication || this.state.phoneAlreadyInAuthentication) {
                if (this.state.detailUserEmail.client_id !== '') {
                    this.setState({
                        detailUser: this.state.detailUserEmail,
                        clientId: this.state.detailUserEmail.client_id,
                        id: this.state.detailUserEmail.nexcare_id,
                        email: this.state.detailUserEmail.email,
                        firstName: this.state.detailUserEmail.first_name,
                        lastName: this.state.detailUserEmail.last_name,
                        username: this.state.detailUserEmail.username,
                        gender: {
                            ...this.state.gender,
                            value: {
                                value: this.state.detailUserEmail.gender === 'L' ? 'L' : this.state.detailUserEmail.gender === 'P' ? 'P' : 'N',
                                label: this.state.detailUserEmail.gender === 'L' ? 'Laki-Laki' : this.state.detailUserEmail.gender === 'P' ? 'Perempuan' : 'Tidak diketahui'
                            }
                        },
                        phoneNumber: this.state.detailUserEmail.phone !== '' ? this.state.detailUserEmail.phone.split('-')[1] : this.state.phoneNumber,
                        createdAt: this.state.detailUserEmail.created_at,
                        updatedAt: this.state.detailUserEmail.updated_at,
                        updatedBy: this.state.detailUserEmail.updated_by,
                    })
                } else {
                    this.setState({
                        detailUser: this.state.detailUserPhone,
                        clientId: this.state.detailUserPhone.client_id,
                        id: this.state.detailUserPhone.nexcare_id,
                        email: this.state.detailUserPhone.email,
                        firstName: this.state.detailUserPhone.first_name,
                        lastName: this.state.detailUserPhone.last_name,
                        username: this.state.detailUserPhone.username,
                        gender: {
                            ...this.state.gender,
                            value: {
                                value: this.state.detailUserPhone.gender === 'L' ? 'L' : this.state.detailUserPhone.gender === 'P' ? 'P' : 'N',
                                label: this.state.detailUserPhone.gender === 'L' ? 'Laki-Laki' : this.state.detailUserPhone.gender === 'P' ? 'Perempuan' : 'Tidak diketahui'
                            }
                        },
                        phoneNumber: this.state.detailUserPhone.phone !== '' ? this.state.detailUserPhone.phone.split('-')[1] : this.state.phoneNumber,
                        createdAt: this.state.detailUserPhone.created_at,
                        updatedAt: this.state.detailUserPhone.updated_at,
                        updatedBy: this.state.detailUserPhone.updated_by,
                    })
                }
            }
            this.setState({
                showSelectUserCategoryModal: false
            })
        }
    }

    handleSubmit = () => {
        if (this.state.emailAlreadyInAuthentication || this.state.phoneAlreadyInAuthentication) {
            let data

            if (this.state.userCategory.value.value === 'cso') {
                data = {
                    client_id: this.state.clientId,
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    cs_lead: this.state.lead.value.value,
                    cs_level: this.state.level.value.value,
                    id_card: this.state.idCard,
                    is_cs: this.state.isCustomerService,
                    assignable: this.state.assignable,
                    is_lead: this.state.isLead,
                    cs_speciality_list: this.state.specialization.value.map(sps => sps.value)
                }
            }

            if (this.state.userCategory.value.value === 'nexsoft') {
                data = {
                    client_id: this.state.clientId,
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    cs_lead: this.state.lead.value.value,
                    id_card: this.state.idCard,
                    is_cs: this.state.isCustomerService,
                    assignable: this.state.assignable,
                    is_lead: this.state.isLead
                }
            }

            if (this.state.userCategory.value.value === 'distributor') {
                data = {
                    client_id: this.state.clientId,
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    id_card: this.state.idCard,
                    is_distributor: true,
                    distributor_list: this.state.distributor.value.map(dst => dst.value)
                }
            }

            if (this.state.userCategory.value.value === 'principal') {
                data = {
                    client_id: this.state.clientId,
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    id_card: this.state.idCard
                }
            }

            API_MASTER_DATA.postDataAddResourceUser(data, this.props.token)
                .then(res => {
                    this.setState({ showSuccessAlert: true })
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false })
                        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)
                    }, 1500);
                }).catch(err => {
                    this.setState({ errorMessage: getErrorMessage(err) })
                    this.setState({ showErrorAlertResponse: true })
                })
        } else {
            let data

            if (this.state.userCategory.value.value === 'cso') {
                data = {
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    cs_lead: this.state.lead.value.value,
                    cs_level: this.state.level.value.value,
                    id_card: this.state.idCard,
                    is_cs: this.state.isCustomerService,
                    assignable: this.state.assignable,
                    is_lead: this.state.isLead,
                    cs_speciality_list: this.state.specialization.value.map(sps => sps.value)
                }
            }

            if (this.state.userCategory.value.value === 'nexsoft') {
                data = {
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    cs_lead: this.state.lead.value.value,
                    id_card: this.state.idCard,
                    is_cs: this.state.isCustomerService,
                    assignable: this.state.assignable,
                    is_lead: this.state.isLead
                }
            }

            if (this.state.userCategory.value.value === 'distributor') {
                data = {
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    id_card: this.state.idCard,
                    is_distributor: true,
                    distributor_list: this.state.distributor.value.map(dst => dst.value)
                }
            }

            if (this.state.userCategory.value.value === 'principal') {
                data = {
                    username: this.state.username,
                    password: this.state.password,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    email: this.state.email,
                    phone: this.state.phoneNumber,
                    country_code: "+62",
                    resource_id: "care",
                    scope: "read write",
                    locale: "id-ID",
                    gender: this.state.gender.value.value,
                    title: this.state.title.value.value,
                    is_admin: false,
                    role_id: this.state.role.value.value,
                    data_group_id: this.state.dataGroup.value.value,
                    role: 'super_admin',
                    alias_name: this.state.firstName + " " + this.state.lastName,
                    id_card: this.state.idCard
                }
            }

            API_MASTER_DATA.postDataAddUser(data, this.props.token)
                .then(res => {
                    this.setState({ showSuccessAlert: true })
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false })
                        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)
                    }, 1500);
                }).catch(err => {
                    this.setState({ errorMessage: getErrorMessage(err) })
                    this.setState({ showErrorAlertResponse: true })
                })
        }
    }

    componentDidMount() {
        this._isMounted = true;

        this.setState({
            showSelectUserCategoryModal: true
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_INSERT]} userPermission={this.props.userDetail.permissions}>
                <div className="user user-add">
                    <MasterDataUserMenu
                        page={this.state.page}
                        handleChangePage={this.handleChangePage}
                    />

                    <div className={this.state.page === 1 ? "block" : "hidden"}>
                        <MasterDataUserFirstPage
                            page={this.state.page}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            detailUser={this.state.detailUser}
                            id={this.state.id}
                            userCategory={this.state.userCategory}
                            isCustomerService={this.state.isCustomerService}
                            assignable={this.state.assignable}
                            email={this.state.email}
                            language={this.state.language}
                            lead={this.state.lead}
                            isLead={this.state.isLead}
                            level={this.state.level}
                            specialization={this.state.specialization}
                            distributor={this.state.distributor}
                            idCard={this.state.idCard}
                            title={this.state.title}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            gender={this.state.gender}
                            countryCode={this.state.countryCode}
                            phoneNumber={this.state.phoneNumber}
                            createdAt={this.state.createdAt}
                            updatedAt={this.state.updatedAt}
                            updatedBy={this.state.updatedBy}
                            handleChangeUserCategory={this.handleChangeUserCategory}
                            handleChangeTitle={this.handleChangeTitle}
                            handleChangeAssignable={this.handleChangeAssignable}
                            handleChangeLanguage={this.handleChangeLanguage}
                            handleChangeGender={this.handleChangeGender}
                            handleChangeLead={this.handleChangeLead}
                            handleChangeIsLead={this.handleChangeIsLead}
                            handleChangeLevel={this.handleChangeLevel}
                            handleChangeSpecialization={this.handleChangeSpecialization}
                            handleChangeDistributor={this.handleChangeDistributor}
                            handleSearchDistributor={this.handleSearchDistributor}
                            action="add"
                        />
                    </div>
                    <div className={this.state.page === 2 ? "block" : "hidden"}>
                        <MasterDataUserSecondPage
                            page={this.state.page}
                            username={this.state.username}
                            password={this.state.password}
                            confirmPassword={this.state.confirmPassword}
                            clientId={this.state.clientId}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            action="add"
                        />
                    </div>
                    <div className={this.state.page === 3 ? "block" : "hidden"}>
                        <MasterDataUserThirdPage
                            page={this.state.page}
                            role={this.state.role}
                            dataGroup={this.state.dataGroup}
                            handleChangeRole={this.handleChangeRole}
                            handleSearchRole={this.handleSearchRole}
                            handleChangeDataGroup={this.handleChangeDataGroup}
                            handleSearchDataGroup={this.handleSearchDataGroup}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            handleSubmit={this.handleSubmit}
                            action="add"
                        />
                    </div>

                    <div className={this.state.showSelectUserCategoryModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <form onSubmit={this.state.canAddUser ? this.handleSubmitInitiateUser : this.handleSubmitUserCategoryModal} className="border-0 rounded shadow-lg bg-white outline-none focus:outline-none p-10 w-1/3">
                                <div className="select-user-category-modal-head flex justify-between">
                                    <div></div>
                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncloseadduser" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)} />
                                </div>
                                <div className="select-user-category-modal-body">
                                    <div className="mb-10">
                                        <p className="text-xl font-bold">Tambah Pengguna Baru</p>
                                        <p className="text-sm">Pastikan data yang anda masukan sudah benar</p>
                                    </div>

                                    <div className="mb-1">
                                        <div className="flex items-center mb-4">
                                            <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                                <p className="mr-1">Kategori Pengguna </p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <div className="w-5/6">
                                                <Select
                                                    id="ddsusercategory"
                                                    placeholder="Pilih Kategori Pengguna"
                                                    options={this.state.userCategory.data}
                                                    onChange={this.handleChangeUserCategory}
                                                    className="w-full"
                                                />
                                                {this.state.showWarningUserCategory && <MasterDataUserAlert text="Kategori Pengguna tidak boleh kosong!" />}
                                            </div>
                                        </div>

                                        <div className="flex items-center mb-4">
                                            <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                                <p className="mr-1">Email </p>
                                                <span className="text-darkred">*</span></div>
                                            <div className="w-5/6">
                                                <input
                                                    type="email"
                                                    id="tslemail"
                                                    className="form-control w-full"
                                                    placeholder="Tulis Email"
                                                    name="email"
                                                    value={this.state.email}
                                                    onChange={this.handleChangeEmail}
                                                    autoComplete="off"
                                                />
                                                {this.state.showWarningAlertEmail && <MasterDataUserAlert text="Email wajib diisi dengan format Email!" />}
                                                {this.state.showWarningAlertEmail2 && <MasterDataUserAlert text="Email tidak boleh kosong!" />}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex items-center mb-4">
                                        <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                            <p className="mr-1">Telepon </p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <div className="w-5/6">
                                            <div className="w-full flex items-center">
                                                <div className="w-1/6 mr-2">
                                                    <input
                                                        type="text"
                                                        id="tslcountrycode"
                                                        className="form-control"
                                                        placeholder="+62"
                                                        name="countryCode"
                                                        value={this.state.countryCode}
                                                        onChange={this.handleChange}
                                                        autoComplete="off"
                                                        disabled
                                                    />
                                                </div>
                                                <div className="w-5/6">
                                                    <input
                                                        type="number"
                                                        id="tslphonenumber"
                                                        className="form-control"
                                                        placeholder="Tulis Nomor Telepon"
                                                        name="phoneNumber"
                                                        value={this.state.phoneNumber}
                                                        onChange={this.handleChangePhone}
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </div>
                                            {this.state.showWarningAlertPhone && <MasterDataUserAlert text="Nomor Telepon wajib diisi dengan format Nomor Telepon!" />}
                                            {this.state.showWarningAlertPhone2 && <MasterDataUserAlert text="Nomor Telepon tidak boleh kosong!" />}
                                        </div>
                                    </div>

                                    <div className={this.state.showAlert ? "flex items-center mb-5" : "hidden"}>
                                        <div className="w-1/6"></div>
                                        <div className="w-5/6 text-xs font-medium flex items-center">
                                            <div>{this.state.canAddUser ? <IconStatusCheck /> : <IconStatusWarn />}</div>
                                            <span className="ml-2">{this.state.messageAlert}</span>
                                        </div>
                                    </div>

                                    <div className="flex justify-center items-center mt-10">
                                        <button type="button" id="btncancel" className="bg-white rounded text-darkblue font-medium border border-lightblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)}>Batal</button>
                                        <button type="submit" id="btnsave" className="bg-darkblue rounded text-white font-medium border border-darkblue focus:outline-none px-10 py-2 mt-3 ml-2" >
                                            {this.state.canAddUser ? 'Selanjutnya' : 'Periksa'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAdd);